// extracted by css-extract-rspack-plugin
export default {"avatarFrame":"Header-module__avatarFrame___ulK3x","text":"Header-module__text___OKQFg"};